import React, { Component } from 'react'
import portrait from '../imgs/headshot.jpg';
import portraitSmall from '../imgs/portrait-small.jpg';
import Resume from '../downloads/AnMaree_Resume.pdf';
import PersonalWorkOne from '../imgs/posters/poster-1.jpg';
import PersonalWorkTwo from '../imgs/posters/poster-2.jpg';
import PersonalWorkThree from '../imgs/posters/poster-3.jpg';
import PersonalWorkSix from '../imgs/posters/poster-6.jpg';
import PersonalWorkSeven from '../imgs/posters/poster-7.jpg';
import PersonalWorkEight from '../imgs/posters/poster-8.jpg';

class Bio extends Component {
  render() {
    return (
      <section>
        <div className="container mt-0 mb-5 my-md-16">
          <div className="row">
            <div className="col-12 col-lg-6 order-3 order-lg-1">
              <section>
                <div className="section-header">
                  <div className="section-title display-4 mb-4">Hi, I'm AnMaree!</div>
                </div>
                <div className="section-content">
                  <p>I’m a Senior UX Designer at Amazon, where I transform complex advertising systems into intuitive, scalable experiences used by thousands of global advertisers and shopping customers. Over the past five years at Amazon, I’ve partnered with product, engineering, and research to design AI-powered ad creatives in Whole Foods, intelligent touch and voice activated workflows on Alexa, and design systems that help advertisers move faster and make smarter decisions.</p>
                  <p>My philosophy is simple: great products are built with equal parts logic and heart. I believe in designing for people—using technology to amplify human intuition, not replace it. I love getting under the hood with engineers, experimenting with emerging tech, and crafting experiences that feel both effortless and intelligent.</p>
                  <p>Before Amazon, I designed for early stage companies in fintech, education, and media across Detroit and New York City — helping founders turn big ideas into meaningful products. I hold a BFA from the University of Michigan, Penny Stamps, School of Art & Design and have been building things since my early MySpace days on my home-island of St. Thomas, US Virgin Islands.</p>
                  <p>When I’m not deep in Figma or code, you’ll find me exploring Oak Park with my family, or perfecting my breakfast taco recipe.</p>
                  <p className="mt-5"><a href={Resume} target="_blank">View My Resume</a></p>
                </div>
              </section>
            </div>
            <div className="col order-1 order-lg-2">
            </div>
            <div className="col-12 col-md-7 col-lg-5 order-lg-1 order-lg-3 mb-5">
              <img className="portait-img d-none d-lg-block" src={portrait} alt="portrait" />
              <img className="portait-small-img d-block d-lg-none" src={portrait} alt="portrait-small" />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Bio